import { useGetMeQuery } from '@/store/api';
import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

type Props = { children: ReactNode };

export const ProtectedRoute = ({ children }: Props) => {
  // 🔑 Simply run the query; RTK Query caches aggressively
  const { data: authInfo, isLoading, isError } = useGetMeQuery();

  if (isLoading) return <p>Loading…</p>; // or your fancy spinner
  if (isError || !authInfo) return <Navigate to='/login' replace />;

  return children;
};
